import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { NOTES_RECOMMENDATIONS_ENDPOINTS } from 'src/app/core/api/endpoints/notes-recommendations.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class NotesRecommendationsService {
  private api = inject(ApiService);

  getSeverityRecommendations(): Observable<any> {
    return this.api
      .get(NOTES_RECOMMENDATIONS_ENDPOINTS.V1.SEVERITIES_AND_CARDS)
      .pipe(shareReplay());
  }

  getNotesRecommendations(orderID): Observable<any> {
    return this.api.get(
      NOTES_RECOMMENDATIONS_ENDPOINTS.V1.RETRIEVE(orderID)
    );
  }

  postNotesRecommendations(orderID, data, buttonId?): Observable<any> {
    return this.api.post(
      NOTES_RECOMMENDATIONS_ENDPOINTS.V1.CREATE(orderID),
      data,
      { context: new HttpContext().set(BUTTON_LOADING_ID, buttonId) }
    );
  }

  deleteNoteRecommendation(noteID): Observable<any> {
    return this.api.delete(
      NOTES_RECOMMENDATIONS_ENDPOINTS.V1.DELETE(noteID)
    );
  }
}
